/**
 * Container for an List View component.
 * Price Group section
 * Opening Times Group section
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { ScreenSection } from '../../api/types'

export interface OwnProps {
	section: ScreenSection
	type: 'price'|'opening_hours'
}

export interface Props {
	section: ScreenSection
}

export interface Actions {}

const mapStateToProps = (_state: RootStoreState, ownProps: OwnProps): Props => {
	return {
		...ownProps,
	}
}

const mapDispatchToProps = (_dispatch: Dispatch<AnyAction>): Actions => ({})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
